import { render, staticRenderFns } from "./Expertises.vue?vue&type=template&id=c4c0b0d6"
import script from "./Expertises.vue?vue&type=script&lang=js"
export * from "./Expertises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports